const jsonHeaders = {
    'Content-Type': 'application/json'
};

const request = (url, options = {}) => fetch(url, {
    credentials: 'include',
    ...options,
    headers: {
        ...(options.body ? jsonHeaders : {}),
        ...options.headers
    }
}).then(async res => {
    const text = await res.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    } catch (e) {
        data = {error: text || res.statusText};
    }
    if (!res.ok) {
        const err = new Error((data && data.error) || res.statusText || 'request failed');
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
});

const register = (username, password) => request('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({username, password})
});

const login = (username, password) => request('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({username, password})
});

const logout = () => request('/api/auth/logout', {method: 'POST'});

const getSession = () => request('/api/auth/session');

const listMyProjects = () => request('/api/projects/mine');

const listPublicProjects = () => request('/api/projects/public');

const getProjectMeta = id => request(`/api/projects/${id}`);

const patchProject = (id, body) => request(`/api/projects/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body)
});

const deleteProject = id => request(`/api/projects/${id}`, {
    method: 'DELETE'
});

export {
    register,
    login,
    logout,
    getSession,
    listMyProjects,
    listPublicProjects,
    getProjectMeta,
    patchProject,
    deleteProject
};
